/**
 * @file Configuration.js
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Wednesday, 10th July 2019 3:22:37 pm
 * @copyright 2015 - 2019 SKAT LLC, Delive LLC
 * @flow
 */
import type { iLogger, iExposedView } from '../types'
import type { WaterlineQuery, iDataProvider } from 'web-panel-essentials/types'

import { Inject } from '../serviceLocator'
import { __ } from '../globals'
import Grid from './grid/Grid'
import { CheckBox } from '../views/forms/components'
import { Row } from 'web-panel/views/forms'
import * as React from 'react'

class Configuration extends React.Component<Object, Object> implements iExposedView<null> {
  @Inject logger : iLogger
  @Inject settingsManager: iDataProvider<any>
  constructor () {
    super()
    this.state = {
      filterEnabled: true
    }
  }

  async data () : Promise<null> {
    return null
  }

  async command () : Promise<void> {

  }

  render () : React.Node {
    let filter : WaterlineQuery
    const { filterEnabled } = this.state
    if (filterEnabled) filter = { where: { name: { ilike: 'operator' } } }

    return (
      <div className='mini-margin'>
        <div style={{ height: 500 }}>
          <Grid name='configuration' autofetch filter={filter} dataProvider={this.settingsManager} />
        </div>
        <Row>
          <CheckBox className='half-margin' label={__('DISPLAY_ONLY_WEB_PANEL_SETTINGS')} value={filterEnabled} onChange={({ value }) => { this.setState({ filterEnabled: value }) }} />
        </Row>
      </div>
    )
  }
}

export default Configuration
